import "@/App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import ResetPassword from "./pages/ResetPassword";
import ForgotPassword from "./pages/ForgotPassword";
import Dashboard from "./pages/Dashboard";
import Censo from "./pages/Censo";
import Recibos from "./pages/Recibos";
import Remesas from "./pages/Remesas";
import Mandatos from "./pages/Mandatos";
import Calendario from "./pages/Calendario";
import Usuarios from "./pages/Usuarios";
import RemesaDetail from "./pages/RemesaDetail";
import Importaciones from "./pages/Importaciones";
import Tarifas from "./pages/Tarifas";
import MiPerfil from "./pages/MiPerfil";
import EventoAsistencia from "./pages/EventoAsistencia";
import Solicitudes from "./pages/Solicitudes";
import Documentos from "./pages/Documentos";
import Contabilidad from "./pages/Contabilidad";
import Notificaciones from "./pages/Notificaciones";
import Grupos from "./pages/Grupos";
import Roles from "./pages/Roles";
import Configuracion from "./pages/Configuracion";
import PoliticaPrivacidad from "./pages/PoliticaPrivacidad";
import Soporte from "./pages/Soporte";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-med-bg text-med-muted">
        Cargando…
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // -----------------------------------
  // FORCE PASSWORD CHANGE
  // -----------------------------------
  if (user.must_change_password && location.pathname !== "/perfil") {
    return <Navigate to="/perfil?tab=seguridad" replace />;
  }

  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              path="/politica-privacidad"
              element={<PoliticaPrivacidad />}
            />
            <Route path="/soporte" element={<Soporte />} />
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Dashboard />} />
              <Route path="/censo" element={<Censo />} />
              <Route path="/tarifas" element={<Tarifas />} />
              <Route path="/recibos" element={<Recibos />} />
              <Route path="/remesas" element={<Remesas />} />
              <Route path="/remesas/:id" element={<RemesaDetail />} />
              <Route path="/mandatos" element={<Mandatos />} />
              <Route path="/calendario" element={<Calendario />} />
              <Route
                path="/eventos/:id/asistencia"
                element={<EventoAsistencia />}
              />
              <Route path="/usuarios" element={<Usuarios />} />
              <Route path="/configuracion" element={<Configuracion />} />
              <Route path="/importaciones" element={<Importaciones />} />
              <Route path="/perfil" element={<MiPerfil />} />
              <Route path="/solicitudes" element={<Solicitudes />} />
              <Route path="/documentos" element={<Documentos />} />
              <Route path="/contabilidad" element={<Contabilidad />} />
              <Route path="/notificaciones" element={<Notificaciones />} />
              <Route path="/grupos" element={<Grupos />} />
              <Route path="/roles" element={<Roles />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
